import { GridItem } from '@chakra-ui/react';
import { forwardRef } from 'react';

import DevSandboxContent from './DevSandboxContent';
import DevSandboxFooter from './DevSandboxFooter';
import DevSandboxNavigation from './DevSandboxNavigation';
import DevSandboxProvider from './DevSandboxProvider';
import DevSandboxShell from './DevSandboxShell';
import { IDevSandboxProps } from './types';

const DevSandbox = forwardRef((devSandboxProps: IDevSandboxProps, ref) => {
  const { mode } = devSandboxProps;

  if (mode === 'full-page' || mode === 'embed') {
    return (
      <DevSandboxProvider ref={ref} {...devSandboxProps}>
        <DevSandboxShell
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          width="100vw"
          height="100vh"
          zIndex="modal"
        >
          <DevSandboxNavigation />
          <DevSandboxContent />
          <DevSandboxFooter />
        </DevSandboxShell>
      </DevSandboxProvider>
    );
  }

  return (
    <DevSandboxProvider ref={ref} {...devSandboxProps}>
      <DevSandboxShell
        useGrid
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        width="100vw"
        height="100vh"
        zIndex="modal"
        gridTemplateRows="60px 1fr 60px"
        gridTemplateColumns="1fr"
      >
        <GridItem rowSpan={1}>
          <DevSandboxNavigation />
        </GridItem>
        <GridItem rowSpan={1} overflow="auto">
          <DevSandboxContent />
        </GridItem>
        <GridItem rowSpan={1}>
          <DevSandboxFooter />
        </GridItem>
      </DevSandboxShell>
    </DevSandboxProvider>
  );
});

export default DevSandbox;
